import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    businessName: Yup.string().required('Enter Business Name'),
    Domain: Yup.object().required('Select Domain'),
    endDate: Yup.mixed().required('Select End Date'),
    Address: Yup.string().max(30, 'Must be 30 characters or less').required('Enter Business Address'),
    country: Yup.object().required("Select Country"),
    state: Yup.object().required('Select State'),
    city: Yup.object().required('Select City'),
    zipCode: Yup.number().typeError('It doesn\'t look like a zip code').positive('A zip code can\'t start with a minus').integer('It can\'t include a decimal point').required('Enter Zip Code'),
    firstname: Yup.string().required('Enter your First Name'),
    lastname: Yup.string().required('Enter your Last Name'),
    username: Yup.string().required('Enter User Name'),
    phone: Yup.string().required('Enter your Phone Number').test('len', 'Must be exactly 10 digits', val => val?.toString().length === 13),
    email: Yup.string().email('Kindly enter valid email').required('Enter your Email Address'),
    // attributeList: Yup.array().of(
    //     Yup.object().shape({
    //         name: Yup.string().required('Kindly enter the attribute name'),
    //         value: Yup.string().required("Kindly enter attribute value"),
    //     })
    // ),
});